module.exports = __webpack_public_path__ + "img/icon_sm_lpsmjgsp.2c5296f8.png";